"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetErrors = exports.deleteTemplateFailed = exports.deleteTemplateSuccess = exports.deleteTemplate = exports.updateTemplateFailed = exports.updateTemplateSuccess = exports.updateTemplate = exports.createTemplateFailed = exports.createTemplateSuccess = exports.createTemplate = exports.getTemplatesFailed = exports.getTemplatesSuccess = exports.getTemplatesRequest = void 0;

var _reduxAct = require("redux-act");

var PREFIX = 'COMMON/PROFILE_SETTINGS/TEMPLATES';
var getTemplatesRequest = (0, _reduxAct.createAction)("".concat(PREFIX, "/GET_TEMPLATES_REQUEST"));
exports.getTemplatesRequest = getTemplatesRequest;
var getTemplatesSuccess = (0, _reduxAct.createAction)("".concat(PREFIX, "/GET_TEMPLATES_SUCCESS"));
exports.getTemplatesSuccess = getTemplatesSuccess;
var getTemplatesFailed = (0, _reduxAct.createAction)("".concat(PREFIX, "/GET_TEMPLATES_FAILED"));
exports.getTemplatesFailed = getTemplatesFailed;
var createTemplate = (0, _reduxAct.createAction)("".concat(PREFIX, "/CREATE_TEMPLATE_REQUEST"));
exports.createTemplate = createTemplate;
var createTemplateSuccess = (0, _reduxAct.createAction)("".concat(PREFIX, "/CREATE_TEMPLATE_SUCCESS"));
exports.createTemplateSuccess = createTemplateSuccess;
var createTemplateFailed = (0, _reduxAct.createAction)("".concat(PREFIX, "/CREATE_TEMPLATE_FAILED"));
exports.createTemplateFailed = createTemplateFailed;
var updateTemplate = (0, _reduxAct.createAction)("".concat(PREFIX, "/UPDATE_TEMPLATE_REQUEST"));
exports.updateTemplate = updateTemplate;
var updateTemplateSuccess = (0, _reduxAct.createAction)("".concat(PREFIX, "/UPDATE_TEMPLATE_SUCCESS"));
exports.updateTemplateSuccess = updateTemplateSuccess;
var updateTemplateFailed = (0, _reduxAct.createAction)("".concat(PREFIX, "/UPDATE_TEMPLATE_FAILED"));
exports.updateTemplateFailed = updateTemplateFailed;
var deleteTemplate = (0, _reduxAct.createAction)("".concat(PREFIX, "/DELETE_TEMPLATE_REQUEST"));
exports.deleteTemplate = deleteTemplate;
var deleteTemplateSuccess = (0, _reduxAct.createAction)("".concat(PREFIX, "/DELETE_TEMPLATE_SUCCESS"));
exports.deleteTemplateSuccess = deleteTemplateSuccess;
var deleteTemplateFailed = (0, _reduxAct.createAction)("".concat(PREFIX, "/DELETE_TEMPLATE_FAILED"));
exports.deleteTemplateFailed = deleteTemplateFailed;
var resetErrors = (0, _reduxAct.createAction)("".concat(PREFIX, "/RESET_ERRORS"));
exports.resetErrors = resetErrors;